/**
 * @file UserDetailsModal.tsx
 * @description
 * -----------------------------------------------------
 * Modal para confirmar el envío del correo de restablecimiento de contraseña
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-04-25
 * @author Correcta
 * @author Leonard Vasilescu
 * @copyright © Correcta
 * @license Private
 * */
import ModalComponent from "@/components/modals/ModalComponent";
import { useTranslations } from "next-intl";

interface SendResetEmailModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SendResetEmailModal = ({ isOpen, onClose }: SendResetEmailModalProps) => {
  const modals = useTranslations("Modals");
  const handleConfirm = () => {
    onClose();
  }
  return (
    <ModalComponent
      title={modals("sendEmail.title")}
      isOpen={isOpen}
      onClose={onClose}
      buttonCancel={false}
      buttonConfirm={true}
      onConfirm={handleConfirm}
      requiredText={false}
    >
      <p>{modals("sendEmail.description")}</p>
    </ModalComponent>
  );
};

export default SendResetEmailModal;
